import { useNavigate } from "react-router-dom";

const UnverifiedEmailCard = () => {
  const navigate = useNavigate();
  const verifyEmail = () => {
    navigate("/verify-email");
  };

  return (
    <div
      className="w-full bg-gray-4 rounded-[10px] border-gray-7 text-white p-4"
      role="alert"
    >
      <p className="font-bold">Email Unverified</p>
      <p>Please verify your email to access all features.</p>
      <button
        onClick={verifyEmail}
        className="mt-2 bg-gray-7 text-white py-2 px-4 rounded"
      >
        Verify E-mail
      </button>
    </div>
  );
};

export default UnverifiedEmailCard;
